import React, { useEffect } from "react";
import { IMask, useIMask } from "react-imask";
import Input from "../Input/Input";
import { parseMoney } from "../../utils/number";

export function PriceInput({ value, onChange, ...props }) {
   const opts = {
      mask: "R$ num",
      blocks: {
         num: {
            mask: IMask.MaskedNumber,
            thousandsSeparator: ".",
            radix: ",",
            // mapToRadix: ["."],
            // scale: 2,
            min: 0,
            max: 999999999,
            signed: false,
         },
      },
   };

   const { ref, setValue, setUnmaskedValue } = useIMask(opts, {
      onAccept: (_maskedValue, mask) => {
         onChange?.({
            target: {
               value: mask.unmaskedValue,
            },
         });
      },
   });

   useEffect(() => {
      if (value == null) return;

      const numericValue = parseMoney(String(value));
      const currentValue = ref.current?.value;

      if (currentValue !== undefined && currentValue === String(value)) {
         return;
      }

      setUnmaskedValue(String(numericValue));
   }, [value, setUnmaskedValue, ref]);

   return (
      <Input
         {...props}
         ref={ref}
         externalMask
         placeholder="R$ 3,00"
      />
   );
}